import { Injectable } from "@angular/core";

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fadl } from '@fortawesome/duotone-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fat } from '@fortawesome/pro-thin-svg-icons';


@Injectable({ providedIn: 'root' })
export class FontAwesomeService {

  constructor(
    private readonly library: FaIconLibrary
  ) {

  }

  async load(){
    this.library.addIconPacks(fas, far, fab, fal, fat, fad, fadl);
  }

}
